import React, { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {
  getCartListLocal, disableFlag,
} from '../redux/actions/cart';
import { refreshTokenLogin } from '../redux/actions/auth';
import TheHeader from './TheHeader';
import TheFooter from './TheFooter';
import BodyWrapper from './BodyWrapper';

const TheLayout = ({ children }) => {
  const cartsLocal = useSelector((state) => state.cart.cartsLocal, shallowEqual);
  const isChangeCart = useSelector((state) => state.cart.isChangeCart, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCartListLocal());
  }, [dispatch, isChangeCart]);

  useEffect(() => {
    dispatch(disableFlag());
  }, [cartsLocal, dispatch]);

  useEffect(() => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken !== null) {
      const param = {
        refresh_token: refreshToken,
      };
      dispatch(refreshTokenLogin(param));
    }
  }, [dispatch]);

  return (
    <BodyWrapper>
      <TheHeader cartLength={cartsLocal.length} isLoggedIn={isLoggedIn} />
      <main className="content" style={{ background: 'rgb(235,244,246)' }}>
        {children}
      </main>
      <TheFooter isLoggedIn={isLoggedIn} />
      <NotificationContainer />
    </BodyWrapper>
  );
};
export default TheLayout;
